import { PresentationControls, Html } from '@react-three/drei'
import { Suspense, useRef, useState } from 'react'
import Fallback from './Fallback.jsx'
import Tv from './Tv.jsx'
import {useRadio} from './medias/collections.js'
import {useMediaSound} from './medias/media-volume.js'
import { Showcase } from './Showcase.jsx'
import { YoutubePlayer } from './YoutubePlayer.jsx'
import { Vignette, EffectComposer } from '@react-three/postprocessing'
import { BlendFunction } from 'postprocessing'
import {isMobileDevice} from './use-is-mobile-device.js'
import MobileDevice from './MobileDevice.jsx'

export default function Experience()
{
    const isMobile = isMobileDevice()
    const tvPosition = { x: 0, y: -0.64, z: -0.96 }
    const tvRotation = { x: 0.2, y: 0, z: 0 }
    const iframePosition = { x: 0, y: 0.47, z: -1.04 }
    const iframeRotation = {x: 0.20, y: -3.14, z: 0 }
    const lightPosition = { x: 0, y: 1.75, z: -2.3 }
    const lightIntensity = 1.2

    const {radio, getNextRadio, getPreviousRadio} = useRadio()
    const {volume, upSound, downSound} = useMediaSound()
    const [isPower, setPower] = useState(false)
    const directionalLightRef = useRef(null)

    return <>
        { isMobile ? <MobileDevice />  : 
        <>
            <EffectComposer>
            <Vignette
                offset={ 0.2 }
                darkness={ 0.6 }
                blendFunction={ BlendFunction.NORMAL }
                />
            </EffectComposer>

            <directionalLight
                ref={ directionalLightRef }
                position={ [ lightPosition.x, lightPosition.y, lightPosition.z ] }
                intensity={ lightIntensity }
            />

            <Suspense fallback={ <Fallback /> }>
                <PresentationControls
                        global
                        rotation={ [ 0, 0, 0 ] }
                        polar={ [ - 0.4, 0.2 ] }
                        azimuth={ [ - 1, 0.75 ] }
                        config={ { mass: 2, tension: 100 } }
                        snap={ { mass: 4, tension: 100 } }
                        cursor={false}
                    >
                    <Tv
                        upSound={upSound}
                        downSound={downSound}
                        getNextRadio={getNextRadio}
                        getPreviousRadio={getPreviousRadio}
                        setPower={setPower}
                        isPower={isPower}
                        scale={ 4 }
                        position={[tvPosition.x, tvPosition.y, tvPosition.z]}
                        rotation={[tvRotation.x, tvRotation.y, tvRotation.z]}
                    />
                    <Html
                    transform
                    distanceFactor={ 1.17 }
                    position={[iframePosition.x, iframePosition.y, iframePosition.z]}
                    rotation={[iframeRotation.x, iframeRotation.y, iframeRotation.z]}
                    >
                        {
                            isPower && <>
                                <Showcase radio={radio} isPower={isPower} volume={volume} />
                                <YoutubePlayer radio={radio} volume={volume}/>
                            </>
                        }
                    </Html>
                </PresentationControls>
            </Suspense>
        </>
        }
    </>
}
